import React, { Component } from 'react';
import styled from 'styled-components';
import {SelectPicker} from 'rsuite';
import {createStructuredSelector} from 'reselect';
import { DevicesSelector, SelectedDeviceSelector } from "../redux/selector";
import { connect } from "react-redux";
import { SetSelectedDevice } from "../redux/actions";

const Container = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  padding: 0 20px;
  align-items: center;
  background-image: linear-gradient(90deg,darkorange 10%,orange,darkorange);
  color: black;
  font-weight: bolder;

  .rs-picker-toggle .rs-picker-toggle-placeholder {
    color: black;
    font-weight: bolder;
  }

  .rs-picker-subtle .rs-btn:focus, .rs-picker-subtle .rs-btn:hover, .rs-picker-subtle .rs-picker-toggle:focus, .rs-picker-subtle .rs-picker-toggle:hover {
    background-color: transparent;
    box-shadow: unset;
  }
  .rs-picker-subtle .rs-btn-active, .rs-picker-subtle .rs-picker-toggle-active {
    background-color: transparent;
    box-shadow: unset;
  }

  .rs-picker-has-value .rs-btn .rs-picker-toggle-value, .rs-picker-has-value .rs-picker-toggle .rs-picker-toggle-value {
    color: black;
  }
  .rs-picker-toggle.rs-btn .rs-picker-toggle-caret {
    fill : black;
  }
`;

class SelectDeviceComponent extends Component {
  render() {
    const { devices, selectedDevice, setSelectedDevice} = this.props;
    return (
      <Container>
        <span>انتخاب دستگاه</span>
        <SelectPicker
          data={devices}
          valueKey="mobile"
          labelKey="name"
          placement="bottomEnd"
          style={{minWidth: "45%"}}
          appearance="subtle"
          searchable={false}
          placeholder="انتخاب دستگاه"
          cleanable={false}
          value={`0${selectedDevice}`}
          onSelect={val => setSelectedDevice(val)}
        />
      </Container>
    );
  }
}


const mapStateToProps = createStructuredSelector({
  devices: DevicesSelector,
  selectedDevice : SelectedDeviceSelector
})
const mapDispatchToProps = dispatch => ({
  setSelectedDevice: device => dispatch(SetSelectedDevice(device))
})


export default connect(mapStateToProps, mapDispatchToProps)(SelectDeviceComponent);